import BudgetActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperBudget:[],
  errorInternal:false
};

function BudgetReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case BudgetActions.RESET_LIST:
      return INITIAL_STATE;
    case BudgetActions.NEW_DATA:
      return { ...state,errorInternal:false,  errorMessage: [],onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case BudgetActions.UPDATE_DATA:
      return { ...state, errorInternal:false, errorMessage: [],onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case BudgetActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case BudgetActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case BudgetActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case BudgetActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case BudgetActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case BudgetActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case BudgetActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case BudgetActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
     case BudgetActions.GET_HELPER:
       return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperBudget:action.payload};
    case BudgetActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case BudgetActions.APPROVE_DATA:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};
    case BudgetActions.REJECT_DATA:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};      
    default:
      return state;
    }
}

export default BudgetReducer;
